// DEPRECATED - replaced by CategoriesGrid. Ensure its dismission in every store before delete it
import { isEmpty } from 'remeda'
import { FreeMode, Mousewheel } from 'swiper'
import { SwiperSlide } from 'swiper/react'
import { useMediaQuery } from 'usehooks-ts'
import { useLiquidSkeleton } from '@velasca/hooks/use-liquid-skeleton'
import { SlideWithLink } from '@velasca/ui/slide-with-link'
import { TitleComposition } from '@velasca/ui/title-composition'
import {
  Container,
  SlidersContainer,
  StyledSwiper,
} from './CarouselsStack.styles'
import type {
  CarouselsStackProps,
  CarouselStackSizes,
} from './CarouselsStack.types'

const carouselStackSizes = {
  mobile: {
    slideMaxWidth: 220,
    slideGap: 20,
    sliderSidePadding: 20,
  },
  desktop: {
    slideMaxWidth: 360,
    slideGap: 20,
    sliderSidePadding: 50,
  },
} as const

const calculateBreakpoint = (
  slidesCount: number,
  { slideMaxWidth, slideGap, sliderSidePadding }: CarouselStackSizes,
) => {
  return (
    slidesCount * slideMaxWidth +
    slideGap * (slidesCount - 1) +
    sliderSidePadding * 2
  )
}

export const CarouselsStack = ({
  upperTitle,
  title,
  sliders,
}: CarouselsStackProps): JSX.Element | null => {
  useLiquidSkeleton('#collections-slider-block')

  const isMinWidth768px = useMediaQuery('(min-width: 768px)')

  if (
    // TODO: tutta la logica di questo IF è da rivedere.
    !title &&
    // @ts-expect-error
    isEmpty(sliders) &&
    // @ts-expect-error
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    !sliders?.every(({ slides }) => isEmpty(slides))
  ) {
    return null
  }

  return (
    <Container>
      {title && <TitleComposition title={title} upperTitle={upperTitle} />}

      {sliders && !isEmpty(sliders) && (
        <SlidersContainer>
          {sliders?.map(({ id, slides }) => {
            const calculatedBreakpoint = calculateBreakpoint(
              slides.length,
              isMinWidth768px
                ? carouselStackSizes.desktop
                : carouselStackSizes.mobile,
            )

            return (
              <StyledSwiper
                freeMode
                key={id}
                slidesPerView={'auto'}
                mousewheel={{ forceToAxis: true }}
                $calculatedBreakpoint={calculatedBreakpoint}
                $carouselStackSizes={carouselStackSizes}
                modules={[FreeMode, Mousewheel]}
                spaceBetween={
                  isMinWidth768px
                    ? carouselStackSizes.desktop.slideGap
                    : carouselStackSizes.mobile.slideGap
                }
                breakpoints={{
                  [calculatedBreakpoint]: {
                    enabled: false,
                  },
                }}
              >
                {slides.map((slide) => (
                  <SwiperSlide key={slide.id}>
                    <SlideWithLink {...slide} />
                  </SwiperSlide>
                ))}
              </StyledSwiper>
            )
          })}
        </SlidersContainer>
      )}
    </Container>
  )
}
